var map = {
	"./addchuxing.png": 3229,
	"./address.png": 4569,
	"./backgroundfive.png": 6134,
	"./backgroundfour.png": 5383,
	"./backgroundone.png": 6667,
	"./backgroundthree.png": 1804,
	"./backgroundtwo.png": 5482,
	"./beijing.png": 6188,
	"./biaoqian.png": 9543,
	"./blue.png": 1094,
	"./boxicon.png": 8334,
	"./icon.png": 7334,
	"./img_center.png": 4455,
	"./left.png": 332,
	"./liucheng.png": 6546,
	"./logo.png": 6949,
	"./market.png": 6830,
	"./mess.png": 7611,
	"./newpic.png": 9795,
	"./newsright.png": 6616,
	"./phone.png": 9156,
	"./qiehuanbg1.png": 6101,
	"./qiehuanbg2.png": 8479,
	"./right.png": 1132,
	"./rights.png": 9629,
	"./search.png": 2305,
	"./time.png": 5963,
	"./title.png": 8988,
	"./topicon.png": 2554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;